export default __webpack_public_path__ + "16aeb97607201dd84b45707259a99e8f.svg";